import { EMPTY_STRING } from '../../../../../../constants/common'

export const APPLICANT_DECISION_NOTE_FIELD_NAME = 'note'

export const APPLICANT_DECISION_MODAL_INITIAL_VALUES = {
  [APPLICANT_DECISION_NOTE_FIELD_NAME]: EMPTY_STRING,
}

export const APPLICANT_DECISION_NOTE_FIELD_MIN_ROWS = 3
